import { palette } from '../palette';

const MuiSelect = {
  iconOutlined: {
    color: palette.text?.primary
  }
};

export default MuiSelect;
